import { useState, useEffect } from 'react';

import Navigation from './components/Navigation';
import Content from './components/Content';

import models from './data/models';
import straps from './data/straps';
import cases from './data/cases';

import './App.css';

function App() {
  const [parsedQueryParams, setParsedQueryParams] = useState(false)

  const [locale, setLocale] = useState('en')
  const [step, setStep] = useState(1)
  const [selectedModel, setSelectedModel] = useState()
  const [selectedColor, setSelectedColor] = useState()
  const [selectedStrap, setSelectedStrap] = useState()
  const [selectedCase, setSelectedCase] = useState()

  useEffect(() => {
    function parseQueryParams() {
      // if query params, parse configuration
      const urlParams = new URLSearchParams(window.location.search);

      let targetStep = 1

      if (urlParams.has('model')) {
        const modelId = urlParams.get('model')
        const matchingModels = models.filter(m => m.id === modelId)
        if (matchingModels.length) {
          const model = matchingModels[0]
          setSelectedModel(model)
          targetStep = 2

          if (urlParams.has('color')) {
            const colorId = urlParams.get('color')
            const matchingColors = model.colors.filter(m => m.id === colorId)
            if (matchingColors.length) {
              const color = matchingColors[0]
              setSelectedColor(color)
              targetStep = 3

              if (urlParams.has('strap')) {
                const strapId = urlParams.get('strap')
                const matchingStraps = straps.filter(m => m.id === strapId)
                if (matchingStraps.length) {
                  const strap = matchingStraps[0]
                  setSelectedStrap(strap)
                  targetStep = 4

                  if (urlParams.has('case')) {
                    const caseId = urlParams.get('case')
                    const matchingCases = cases.filter(m => m.id === caseId)
                    if (matchingCases.length) {
                      const targetCase = matchingCases[0]
                      setSelectedCase(targetCase)
                      targetStep = 5
                    }
                  }
                }
              }
            }
          }
        }
      }

      setStep(targetStep)
    }

    // try to remove Tidio
    try {
      const tdc = document.querySelector('#tidio-chat')
      if (tdc) tdc.remove()
    } catch (e) {
      console.log(e)
    }

    // set locale
    let pathLocale = 'en';
    if (document.location.pathname.startsWith('/de/')) {
      pathLocale = 'de'
    } else if (document.location.pathname.startsWith('/fr/')) {
      pathLocale = 'fr'
    }
    setLocale(pathLocale)

    if (!parsedQueryParams) {
      parseQueryParams()
      setParsedQueryParams(true)
    }
  }, [parsedQueryParams])

  function tryToSetStep(newStep) {
    switch (newStep) {
      case 1:
        setStep(1)
        break;
      case 2:
        if (selectedModel) {
          setStep(2)
        } else {
          tryToSetStep(newStep-1)
        }
        break;
      case 3:
        if (selectedColor) {
          setStep(3)
        } else {
          tryToSetStep(newStep-1)
        }
        break;
      case 4:
        if (selectedStrap) {
          setStep(4)
        } else {
          tryToSetStep(newStep-1)
        }
        break;
      case 5:
        if (selectedCase) {
          setStep(5)
        } else {
          tryToSetStep(newStep-1)
        }
        break;
      default:

    }
  }

return (
  <div className="App">

 <div
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1px 20px',
    borderBottom: '1px solid #e5e5e5'
  }}
>
 <button
  style={{
    width: '40px',
    height: '40px',
    background: 'white',
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '22px',
    color: '#777'
  }}
  onClick={() => {
    if (step > 1) {
      tryToSetStep(step - 1)
    } else {
      window.location.href = 'https://www.milus.com'
    }
  }}
>
  ←
</button>

  <a href="https://www.milus.com">
    <img
      src="/milus-logo.png"
      alt="Milus"
      style={{ height: '120px' }}
    />
  </a>

  <div style={{ width: '40px' }}></div>
</div>

    <Navigation
      locale={locale}
      step={step} setStep={v => tryToSetStep(v)}
      selectedModel={selectedModel} setSelectedModel={e => setSelectedModel(e)}
      selectedColor={selectedColor} setSelectedColor={e => setSelectedColor(e)}
      selectedStrap={selectedStrap} setSelectedStrap={e => setSelectedStrap(e)}
      selectedCase={selectedCase} setSelectedCase={e => setSelectedCase(e)}
      />
<Content
  locale={locale}
  step={step} setStep={v => setStep(v)}
  selectedModel={selectedModel} setSelectedModel={e => setSelectedModel(e)}
  selectedColor={selectedColor} setSelectedColor={e => setSelectedColor(e)}
  selectedStrap={selectedStrap} setSelectedStrap={e => setSelectedStrap(e)}
  selectedCase={selectedCase} setSelectedCase={e => setSelectedCase(e)}
/>

<div
  style={{
    textAlign: 'center',
    marginTop: '40px',
    padding: '20px',
    color: '#777',
    fontSize: '12px'
  }}
>
  © Milus International SA 2026
</div>

</div>
);
}

export default App;
